const sanitizeCsvDirective = (app) => {
    app.directive('sanitize-csv', {
        mounted(el) {
            // Add an event listener to sanitize input on change
            el.addEventListener('input', handleInputChange);
        },
        updated(el) {
            // Ensure the input is sanitized when the value is updated
            el.value = escapeForCSV(el.value);
        },
        beforeUnmount(el) {
            // Clean up the event listener when the directive is removed
            el.removeEventListener('input', handleInputChange);
        }
    });

    function handleInputChange(event) {
        const el = event.target;
        el.value = escapeForCSV(el.value); // sanitize the input as user types
    }

    function escapeForCSV(str) {
        if (typeof str !== 'string') return str;

        // Regex pattern to match strings starting with `=`, `+`, `-`, or `@`
        const csvInjectionRegex = /^[=\+\-@]/;

        // If the string starts with a dangerous character, prefix it with a single quote
        return csvInjectionRegex.test(str) ? `'${str}` : str;
    }
};

export default sanitizeCsvDirective;
